import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col justify-center items-center h-full"
}
const _hoisted_3 = { class: "text-red-500 mb-4" }
const _hoisted_4 = {
  key: 2,
  class: "p-4 sm:p-6 lg:p-8"
}
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "text-2xl font-bold text-gray-800" }
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = {
  key: 0,
  class: "mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg"
}
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "text-blue-800" }
const _hoisted_11 = { class: "space-y-6" }
const _hoisted_12 = { class: "flex justify-between items-center" }
const _hoisted_13 = { class: "text-sm font-medium text-gray-600" }
const _hoisted_14 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_15 = {
  key: 0,
  class: "text-center py-8 text-gray-500"
}
const _hoisted_16 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_17 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_18 = { class: "divide-y divide-gray-200" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_20 = { class: "text-xs text-gray-500" }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap text-sm" }
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_24 = { class: "font-medium" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_28 = { class: "text-xs text-gray-500" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_30 = { class: "px-6 py-4 text-sm text-gray-700" }
const _hoisted_31 = { class: "max-w-md whitespace-pre-wrap" }
const _hoisted_32 = { class: "px-6 py-4 text-sm" }
const _hoisted_33 = {
  key: 0,
  class: "grid grid-cols-3 gap-2 min-w-[9rem]"
}
const _hoisted_34 = ["src", "onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "text-gray-400 text-sm"
}
const _hoisted_37 = { class: "px-6 py-4 whitespace-nowrap text-sm" }
const _hoisted_38 = { class: "flex items-center gap-2" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "absolute top-full left-0 mt-1 bg-white border border-gray-300 rounded shadow-lg z-10 min-w-[120px]" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["id", "onChange"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 3,
  class: "text-center py-10"
}
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
}
const _hoisted_50 = {
  key: 4,
  class: "fixed inset-0 z-50 bg-black bg-opacity-75 flex items-center justify-center"
}
const _hoisted_51 = { class: "bg-white p-4 rounded-lg w-full max-w-2xl" }
const _hoisted_52 = ["src"]

import { useRoute } from "vue-router";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { onMounted, ref, nextTick, computed } from "vue";
import { useTask } from "@/composables/tasks/useTask";
import { usePreChallenge } from "@/composables/tasks/pre-challenge/usePreChallenge";
import { useNotifications } from "@/composables/useNotifications";

import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import InstructionsModal from "@/components/v2/Tasks/AnimalTransfer/Modals/InstructionsModal.vue";
import TaskDependencyWarningModal from "@/components/v2/Tasks/Task/TaskDependencyWarningModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PreChallengeTaskPage',
  setup(__props) {

const { startObserver } = useTask();

const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key)

const showCameraModal = ref(false);
const currentDilutionKey = ref<string>('');
const videoStream = ref<MediaStream | null>(null);
const videoElement = ref<HTMLVideoElement | null>(null);
const canvasElement = ref<HTMLCanvasElement | null>(null);

const showImagePreview = ref(false);
const previewImageUrl = ref('');
const activeDropdown = ref<string | null>(null);
const instructionsModal = ref(false);
const isLoading = ref(true);
const isFinishing = ref(false);
const error = ref('');

// ===================================================================
// Composables
// ===================================================================
const { activeTask } = useTask();
const { showTaskCompletionSuccess, showError } = useNotifications();
const {
    dependentChallengeTask,
    completedDilutions,
    incompleteDilutions,
    completionProgress,
    isAllCompleted,
    markDilutionComplete,
    markDilutionIncomplete,
    addPhoto,
    removePhoto,
    getSourceDilutionName,
} = usePreChallenge();

const displayDilutions = computed(() => [
    ...incompleteDilutions.value,
    ...completedDilutions.value,
]);

const init = async () => {
    isLoading.value = true;
    error.value = '';

    if (!taskKey) {
        error.value = 'Invalid task key';
        isLoading.value = false;
        return;
    }

    try {
        const task = await TasksService.startTask(taskKey);
        if (!task) {
            error.value = 'Task not found';
            isLoading.value = false;
            return;
        }
        await useTasksStore().setActiveTask(task);
        startObserver();
    } catch (err) {
        error.value = err instanceof Error ? err.message : 'Failed to load task';
    } finally {
        isLoading.value = false;
    }
};

const handleRetry = () => {
    init();
};

// ===================================================================
// Methods
// ===================================================================
const formatStatus = (status: string) => {
    return status
        .replace(/_/g, ' ')
        .replace(/\b\w/g, letter => letter.toUpperCase());
};

const readFileAsBase64 = (file: File): Promise<{ name: string, data: string }> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve({
                name: file.name,
                data: reader.result as string
            });
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};

const toggleDropdown = (dilutionKey: string) => {
    if (activeDropdown.value === dilutionKey) {
        activeDropdown.value = null;
    } else {
        activeDropdown.value = dilutionKey;
    }
};

const closeDropdown = () => {
    activeDropdown.value = null;
};

const openImagePreview = (imageUrl: string) => {
    previewImageUrl.value = imageUrl;
    showImagePreview.value = true;
};

const closeImagePreview = () => {
    showImagePreview.value = false;
    previewImageUrl.value = '';
};

const formatScientificNotation = (value: number | string | null) => {
    // Handle null, undefined, or empty values
    if (value === null || value === undefined || value === '') {
        return 'Not calculated';
    }

    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    // Handle NaN or invalid numbers
    if (isNaN(num) || !isFinite(num)) {
        return 'Invalid value';
    }

    const exp = num.toExponential(2);
    const [coefficient, exponent] = exp.split('e');
    const exp_num = parseInt(exponent);

    const superscripts: Record<string, string> = {
        '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴',
        '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹',
        '-': '⁻', '+': '⁺'
    };

    const superscriptExp = exp_num.toString().split('').map(char => superscripts[char] || char).join('');

    return `${coefficient} × 10${superscriptExp}`;
};

const handlePhotoUpload = async (dilutionKey: string, event: Event) => {
    const files = (event.target as HTMLInputElement).files;
    if (!files || files.length === 0) return;

    try {
        const photoDataArray = await Promise.all(
            Array.from(files).map(file => readFileAsBase64(file))
        );

        console.log('Photo data array:', photoDataArray);
        // Use the addPhoto method from composable to add photos directly to activeTask
        photoDataArray.forEach(photo => {
            addPhoto(dilutionKey, photo.data);
        });
        console.log('Photos added to dilution:', dilutionKey);
    } catch (error) {
        console.error('Error reading files:', error);
        alert('Failed to read and encode the selected files.');
    }
};

const startCamera = async (dilutionKey: string) => {
    currentDilutionKey.value = dilutionKey;
    showCameraModal.value = true;

    await nextTick();

    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: 'environment', // Use back camera
                width: { ideal: 1280 },
                height: { ideal: 720 }
            }
        });

        videoStream.value = stream;

        if (videoElement.value) {
            videoElement.value.srcObject = stream;
            videoElement.value.play();
        }
    } catch (error) {
        console.error('Error accessing camera:', error);
        alert('Unable to access camera. Please check permissions.');
        closeCameraModal();
    }
};

const capturePhoto = async () => {
    if (!videoElement.value || !canvasElement.value || !videoStream.value) return;

    const video = videoElement.value;
    const canvas = canvasElement.value;
    const context = canvas.getContext('2d');

    if (!context) return;

    // Set canvas dimensions to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame to canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to blob
    canvas.toBlob(async (blob) => {
        if (blob && currentDilutionKey.value) {
            try {
                // Create a File from the blob
                const file = new File([blob], `dilution-${currentDilutionKey.value}-${Date.now()}.jpg`, {
                    type: 'image/jpeg'
                });

                const photoData = await readFileAsBase64(file);
                console.log('Camera photo data:', photoData);
                // Use the addPhoto method from composable to add photo directly to activeTask
                addPhoto(currentDilutionKey.value, photoData.data);
                console.log('Camera photo added to dilution:', currentDilutionKey.value);
                closeCameraModal();
            } catch (error) {
                console.error('Error processing captured photo:', error);
                alert('Failed to save photo');
            }
        }
    }, 'image/jpeg', 0.8);
};

const closeCameraModal = () => {
    if (videoStream.value) {
        videoStream.value.getTracks().forEach(track => track.stop());
        videoStream.value = null;
    }
    showCameraModal.value = false;
    currentDilutionKey.value = '';
};

const handleCameraPhoto = (dilutionKey: string) => {
    if (navigator.mediaDevices) {
        startCamera(dilutionKey);
    } else {
        alert('Camera not supported on this device');
        handleFilePhoto(dilutionKey);
    }
};

const handleFilePhoto = (dilutionKey: string) => {
    const input = document.getElementById(`file-${dilutionKey}`) as HTMLInputElement;
    input?.click();
};

const showInstructions = () => {
    instructionsModal.value = true;
};

const toggleInstructionsModal = () => {
    instructionsModal.value = !instructionsModal.value;
};

const handleFinishTask = async () => {
    if (!activeTask.value) return;

    isFinishing.value = true;

    try {
        console.log('Starting handleFinishTask');
        console.log('activeTask.value:', activeTask.value);
        console.log('Task details:', activeTask.value.details);
        
        // No need to sync - we're working directly with activeTask data
        await TasksService.finishTask(activeTask.value);
        showTaskCompletionSuccess(activeTask.value.title);
    } catch (error) {
        console.error('Error completing task:', error);
        showError("Task Completion Failed", "Failed to complete task. Please try again.");
    } finally {
        isFinishing.value = false;
    }
};

onMounted(() => {
    init();
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (!target.closest('.relative')) {
            activeDropdown.value = null;
        }
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutMain, null, {
    mainArea: _withCtx(() => [
      _createVNode(TaskDependencyWarningModal),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary" }, null, -1)
          ])))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                onClick: handleRetry,
                class: "px-4 py-2 bg-primary text-white rounded"
              }, "Retry")
            ]))
          : (_unref(activeTask))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(activeTask).title), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(activeTask).description), 1)
                ]),
                (_unref(dependentChallengeTask))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-semibold text-blue-900" }, "Dependent Challenge Task", -1)),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(dependentChallengeTask).title), 1)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-3 py-1 text-sm font-medium rounded-full", {
                            'bg-green-100 text-green-800': _unref(dependentChallengeTask).status === 'finished',
                            'bg-yellow-100 text-yellow-800': _unref(dependentChallengeTask).status === 'pending',
                            'bg-blue-100 text-blue-800': _unref(dependentChallengeTask).status === 'in_progress'
                        }])
                        }, _toDisplayString(formatStatus(_unref(dependentChallengeTask).status)), 3)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-700" }, "Dilutions", -1)),
                    _createElementVNode("span", _hoisted_13, "Progress: " + _toDisplayString(_unref(completionProgress).toFixed(0)) + "%", 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (displayDilutions.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No dilutions available "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("table", _hoisted_17, [
                            _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Dilution "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Status "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Source "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Volume "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Resulting Concentration "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Instructions "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Photos "),
                                _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, " Actions ")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", _hoisted_18, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayDilutions.value, (dilution) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: dilution.key,
                                  class: _normalizeClass(dilution.completed ? 'bg-green-50' : 'bg-white hover:bg-gray-50')
                                }, [
                                  _createElementVNode("td", _hoisted_19, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["font-medium", dilution.completed ? 'text-green-800' : 'text-primary'])
                                    }, " Dilution #" + _toDisplayString(dilution.dilutionNumber), 3),
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(dilution.dilutionRatio), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_21, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["px-2 py-0.5 text-xs font-medium rounded-full", dilution.completed ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'])
                                    }, _toDisplayString(dilution.completed ? 'Completed' : 'In progress'), 3)
                                  ]),
                                  _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(getSourceDilutionName)(dilution)), 1),
                                  _createElementVNode("td", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                      (dilution.totalVolume !== null && dilution.totalVolume !== undefined)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(dilution.totalVolume), 1))
                                        : (dilution.volumeAdded !== null && dilution.volumeAdded !== undefined && dilution.diluentVolume !== null && dilution.diluentVolume !== undefined)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(dilution.volumeAdded + dilution.diluentVolume), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_27, " N/A "))
                                    ]),
                                    _createElementVNode("div", _hoisted_28, " Added: " + _toDisplayString(dilution.volumeAdded ?? 'N/A') + " · " + _toDisplayString(dilution.diluentType || 'Diluent') + ": " + _toDisplayString(dilution.diluentVolume ?? 'N/A'), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_29, _toDisplayString(formatScientificNotation(dilution.resultingConcentration)), 1),
                                  _createElementVNode("td", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(dilution.instructions), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_32, [
                                    (dilution.photos && dilution.photos.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dilution.photos, (photo, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: index,
                                              class: "relative group"
                                            }, [
                                              _createElementVNode("img", {
                                                src: photo,
                                                alt: "Photo",
                                                class: "w-20 h-14 object-cover rounded-md cursor-pointer",
                                                onClick: ($event: any) => (openImagePreview(photo))
                                              }, null, 8, _hoisted_34),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_unref(removePhoto)(dilution.key, index)),
                                                class: "absolute top-1 right-1 bg-red-600 text-white rounded-full p-1 text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                                              }, " × ", 8, _hoisted_35)
                                            ]))
                                          }), 128))
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_36, "No photos"))
                                  ]),
                                  _createElementVNode("td", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      (!dilution.completed)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("button", {
                                              onClick: ($event: any) => (_unref(markDilutionComplete)(dilution.key)),
                                              class: "px-3 py-1 text-sm bg-green-500 text-white rounded hover:bg-green-600"
                                            }, " Complete ", 8, _hoisted_39),
                                            _createElementVNode("div", _hoisted_40, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (toggleDropdown(dilution.key)),
                                                class: "px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
                                              }, " Add Photo ▼ ", 8, _hoisted_41),
                                              _withDirectives(_createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("button", {
                                                  onClick: ($event: any) => {handleCameraPhoto(dilution.key); closeDropdown()},
                                                  class: "block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                }, "Camera", 8, _hoisted_43),
                                                _createElementVNode("button", {
                                                  onClick: ($event: any) => {handleFilePhoto(dilution.key); closeDropdown()},
                                                  class: "block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                                }, "Upload File", 8, _hoisted_44)
                                              ], 512), [
                                                [_vShow, activeDropdown.value === dilution.key]
                                              ])
                                            ]),
                                            _createElementVNode("input", {
                                              type: "file",
                                              id: `file-${dilution.key}`,
                                              class: "hidden",
                                              accept: "image/*",
                                              multiple: "",
                                              onChange: ($event: any) => (handlePhotoUpload(dilution.key, $event))
                                            }, null, 40, _hoisted_45)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            onClick: ($event: any) => (_unref(markDilutionIncomplete)(dilution.key)),
                                            class: "px-3 py-1 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600"
                                          }, " Undo ", 8, _hoisted_46))
                                    ])
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ])
                        ]))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_47, _cache[4] || (_cache[4] = [
                _createElementVNode("p", null, "Loading task...", -1)
              ]))),
      _createVNode(FooterActions, null, {
        start: _withCtx(() => [
          _createElementVNode("button", {
            onClick: showInstructions,
            class: "w-full"
          }, " Instructions ")
        ]),
        end: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleFinishTask,
            class: _normalizeClass(["w-full flex items-center justify-center", { 'opacity-50 cursor-not-allowed': !_unref(isAllCompleted) || isFinishing.value }]),
            disabled: !_unref(isAllCompleted) || isFinishing.value
          }, [
            (isFinishing.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(isFinishing.value ? 'Finishing...' : 'Finish Task'), 1)
          ], 10, _hoisted_48)
        ]),
        _: 1
      }),
      (showCameraModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("video", {
                ref_key: "videoElement",
                ref: videoElement,
                class: "w-full rounded",
                autoplay: "",
                playsinline: ""
              }, null, 512),
              _createElementVNode("canvas", {
                ref_key: "canvasElement",
                ref: canvasElement,
                class: "hidden"
              }, null, 512),
              _createElementVNode("div", { class: "mt-4 flex justify-center space-x-4" }, [
                _createElementVNode("button", {
                  onClick: capturePhoto,
                  class: "px-4 py-2 bg-primary text-white rounded"
                }, "Capture"),
                _createElementVNode("button", {
                  onClick: closeCameraModal,
                  class: "px-4 py-2 bg-gray-300 rounded"
                }, "Cancel")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (showImagePreview.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: "fixed inset-0 z-50 bg-black bg-opacity-75 flex items-center justify-center",
            onClick: closeImagePreview
          }, [
            _createElementVNode("img", {
              src: previewImageUrl.value,
              alt: "Image Preview",
              class: "max-w-4xl max-h-[90vh] object-contain rounded-lg"
            }, null, 8, _hoisted_52),
            _createElementVNode("button", {
              onClick: _withModifiers(closeImagePreview, ["stop"]),
              class: "absolute top-4 right-4 text-white text-3xl font-bold"
            }, "×")
          ]))
        : _createCommentVNode("", true),
      _createVNode(InstructionsModal, {
        showModal: instructionsModal.value,
        onClose: toggleInstructionsModal
      }, null, 8, ["showModal"])
    ]),
    _: 1
  }))
}
}

})